import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, isRef as _isRef, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from './../assets/BraddockExterior.jpg'
import _imports_1 from './../assets/ColumbiaExterior.jpg'
import _imports_2 from './../assets/DunnExterior.jpg'
import _imports_3 from './../assets/McPhersonExterior.jpg'
import _imports_4 from './../assets/view.png'
import _imports_5 from '../assets/button-download-icon.svg'
import _imports_6 from '../assets/elevator-icon.svg'
import _imports_7 from './../assets/plus-circle.svg'
import _imports_8 from './../assets/minus-circle.svg'
import _imports_9 from './../assets/sync-alt.svg'


const _hoisted_1 = { class: "site_plan" }
const _hoisted_2 = {
  key: 0,
  class: "leftPanel"
}
const _hoisted_3 = { class: "select_form" }
const _hoisted_4 = { class: "model_selection_header" }
const _hoisted_5 = { class: "radio_selection" }
const _hoisted_6 = { class: "price_text" }
const _hoisted_7 = { class: "pic_holder" }
const _hoisted_8 = { class: "price_text" }
const _hoisted_9 = { class: "pic_holder" }
const _hoisted_10 = { class: "price_text" }
const _hoisted_11 = { class: "pic_holder" }
const _hoisted_12 = { class: "price_text" }
const _hoisted_13 = { class: "pic_holder" }
const _hoisted_14 = { class: "price_text" }
const _hoisted_15 = { class: "pic_holder" }
const _hoisted_16 = {
  key: 0,
  class: "select_form"
}
const _hoisted_17 = { class: "checkbox-group" }
const _hoisted_18 = {
  key: 1,
  class: "statusLegend"
}
const _hoisted_19 = {
  key: 1,
  class: "topPanel"
}
const _hoisted_20 = { class: "midPanel" }
const _hoisted_21 = { id: "buttonSide" }
const _hoisted_22 = { class: "actionButton" }
const _hoisted_23 = { class: "actionButton" }
const _hoisted_24 = { class: "actionButton" }
const _hoisted_25 = {
  key: 2,
  class: "bottomPanel"
}
const _hoisted_26 = { class: "select_form" }
const _hoisted_27 = { class: "model_selection_header" }
const _hoisted_28 = { class: "radio_selection" }
const _hoisted_29 = { class: "price_text" }
const _hoisted_30 = { class: "pic_holder" }
const _hoisted_31 = { class: "price_text" }
const _hoisted_32 = { class: "pic_holder" }
const _hoisted_33 = { class: "price_text" }
const _hoisted_34 = { class: "pic_holder" }
const _hoisted_35 = { class: "price_text" }
const _hoisted_36 = { class: "pic_holder" }
const _hoisted_37 = { class: "price_text" }
const _hoisted_38 = { class: "pic_holder" }
const _hoisted_39 = {
  key: 0,
  class: "select_form"
}
const _hoisted_40 = { class: "checkbox-group" }
const _hoisted_41 = {
  key: 1,
  class: "statusLegend"
}
const _hoisted_42 = { class: "lotName" }
const _hoisted_43 = { class: "modalAboveImageText" }
const _hoisted_44 = { class: "modalFloorplanName" }
const _hoisted_45 = {
  key: 0,
  class: "modalInfotext"
}
const _hoisted_46 = {
  key: 1,
  class: "modalInfotext"
}
const _hoisted_47 = ["src"]
const _hoisted_48 = ["href"]
const _hoisted_49 = ["href"]

import axios from "axios";
import { onBeforeMount, onMounted, ref, watch } from "vue";
import Panzoom from "@panzoom/panzoom";
import { appStore } from "@/stores/app-store";
import UnitModal from '@/components/UnitModal.vue';
import FilterModal from '@/components/FilterModal.vue';
import LoadingModal from '@/components/LoadingModal.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'SitePlanComponent',
  setup(__props) {

const store = appStore();

// const svgImgSrc = ref();
const svgDiv = ref();
const braddockExterior = ref();
const columbiaExterior = ref();
const dunnExterior = ref();
const mcPhersonExterior = ref();

const showUnitModal = ref(false);
const showEmbedForm = ref(false);
const showFilterModal = ref(false);
const selectedLotId = ref('');
const modalTitleText = ref();
const lotPriceText = ref();
const lotFloorplanName = ref('');
const lotUnitInfoText = ref();

const showLoadingModal = ref(false);

const onlyCTA = ref(false);

const zoomInRef = ref();
const zoomOutRef = ref();
const zoomResetRef = ref();
const siteplanImgContainer = ref();
const controlRightOffest = ref('15px');

const addisonPrice = ref("");
const braddockPrice = ref("From $1,249,000");
const columbiaPrice = ref("From $989,000");
const dunnPrice = ref("From $1,259,000");
const mcphersonPrice = ref("From $1,549,000");

let unitsAvailable = ref(0);
let elevatorUnit = false;

let panning = false;
let panzoom: any;

let floorplan = ref(store.floorplanFilter);
let status = ref(store.statusFilter);
const showOnlyElevator = ref(false);

const isWideScreen = ref(true);

let theBarnLogoElement: any;

watch(showUnitModal, (newShow, oldShow) => {
  if (newShow) {
    document.body.classList.add("modal-open");
  } else {
    document.body.classList.remove("modal-open");
  }
});

onBeforeMount(() => {
  console.log("Before mount");

  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);

  if (urlParams.has('only_cta')) {
    let only_cta = urlParams.get('only_cta');
    onlyCTA.value = only_cta == 'true';
  }

  if (onlyCTA.value) {
    addisonPrice.value = '';
    braddockPrice.value = '';
    columbiaPrice.value = '';
    dunnPrice.value = '';
    mcphersonPrice.value = '';
  }
});

onMounted(() => {
  var svgHtml = document.querySelector('#svgImage');
  axios.get("WF_SitePlan.svg").
    then((data: any) => {
      store.siteSVG = data.data;
      svgDiv.value.innerHTML = store.siteSVG;
      initPanzoom();
      axios.get("https://homedesigner.truevistavr.com/siteplanAPI/siteplan/WestFalls")
        .then((data: any) => {
          store.unitsData = data.data;
          iterateSVG();

          //Setting right pan location after svg loaded etc
          setTimeout(() => {
            panzoom.reset();
          }, 50);
        });
    });
  window.addEventListener("resize", windowResizeChange);
  windowResizeChange();

  if (!onlyCTA.value)
    axios.get("https://homedesigner.truevistavr.com/siteplanAPI/prices/16")
      .then((data: any) => {
        data.data.forEach((element: any) => {
          switch (element.name) {
            case 'The Addison':
              addisonPrice.value = element.pricing;
              break;
            case 'The Braddock':
              braddockPrice.value = element.pricing;
              break;
            case 'The Columbia':
              columbiaPrice.value = element.pricing;
              break;
            case 'The Dunn':
              dunnPrice.value = element.pricing;
              break;
            case 'The McPherson':
              mcphersonPrice.value = element.pricing;
              break;
            default:
              break;
          }
        });
      });
  console.log("Site Plan Mounted: Adding Message Listener");
  window.addEventListener("message", (event) => {
    if (window.location == window.parent.location) {
      console.log("Not an Iframe");
      return;
    }
    if (typeof event.data != "string" || !event.data.startsWith("[SitePlan]")) {
      //console.log("Site Plan received unrecognized data: ", event.data);
      return;
    }

    const message = event.data.substring(10);
    console.log("Data received: " + message);
    window.parent.postMessage("[SitePlan]Data Received", "*");

    if (message.length == 0) return;

    const urlParams = new URLSearchParams(message);

    let filtersChanged = false;

    if (urlParams.has('floorplan')) {
      const paramFloorplan = urlParams.get('floorplan') || '';
      store.floorplanFilter = paramFloorplan;
      floorplan.value = paramFloorplan;
      filtersChanged = true;
    }

    if (urlParams.has('status')) {
      const paramStatus = urlParams.get('status') || '';
      store.statusFilter = paramStatus;
      status.value = paramStatus;
      filtersChanged = true;
    }

    if (filtersChanged && store.unitsData.length > 0) {
      console.log("Unit data already loaded, refreshing site plan with the new filters");
      iterateSVG();
    }
  })

  console.log("Site Plan: Sending a ready message");
  window.parent.postMessage("[SitePlan]Ready", "*");
});

const windowResizeChange = () => {
  if (siteplanImgContainer.value.clientWidth > siteplanImgContainer.value.clientHeight) {
    controlRightOffest.value =
      ((siteplanImgContainer.value.clientWidth - siteplanImgContainer.value.clientHeight) / 2) + 15 + "px";
  } else {
    controlRightOffest.value = "15px";
  }
  isWideScreen.value = window.innerWidth >= 1024;// || (window.matchMedia("(orientation: landscape)").matches);
};
function filterModelChange(newFilter: string) {
  if (floorplan.value == newFilter) {
    floorplan.value = "";
  } else {
    floorplan.value = newFilter;
  }
  console.log("Filter changed");
  store.floorplanFilter = floorplan.value;
  iterateSVG();
}

function filterStatusChange() {
  store.statusFilter = status.value != "All" ? status.value : "";
  if (status.value == "All") {
    status.value = "";
  }
  iterateSVG();
}


function iterateSVG() {
  var svgHtml = document.querySelector('#svgImage');
  //svgHtml!.innerHTML = store.siteSVG;
  unitsAvailable.value = 0;

  let svg = svgDiv.value.children[0];
  svg.querySelectorAll('circle').forEach((element: any) => {
    let elementClass = element.getAttribute('class');
    if (elementClass == "tempCircle") {
      element.remove();
    }
  });

  svg.querySelectorAll('g').forEach((element: any) => {
    let elementID = element.getAttribute('id');

    if (elementID == null)
      return;

    if (elementID == "TheBarnLogo") {
      theBarnLogoElement = element;
    }

    elementID = elementID.substring(1);
    let findEl = store.unitsData.find((obj: any) => { return obj.unitId === elementID });
    let rectElem = element.querySelector('rect');

    if (rectElem == null) rectElem = element.querySelector('path');

    if (findEl == null || rectElem == null)
      return;

    let triangleElem: any;
    let allPaths = element.querySelectorAll('path');
    if (allPaths.length == 2) {
      triangleElem = allPaths[1];
    } else if (allPaths.length == 1 && allPaths[0] != rectElem) {
      triangleElem = allPaths[0];
    }

    if (triangleElem != null) {
      triangleElem.style = "fill:#fff;pointer-events: none;";
    }

    rectElem.onclick = () => {
      if (panning) return;
      if (findEl!.status == "AFF" || findEl!.floorPlanName == "Amber") return;
      lotFloorplanName.value = findEl!.floorPlanName;
      selectedLotId.value = findEl!.unitName;
      modalTitleText.value = "Homesite " + findEl!.unitName;
      lotPriceText.value = findEl!.status == "Available" ?
        `$${(findEl!.startingPrice * 1000).toLocaleString("EN-US")}` : "";
      if (findEl!.status == "ComingSoon") lotPriceText.value = "Coming Soon";
      lotUnitInfoText.value = findEl!.infoText;
      showUnitModal.value = true;
      elevatorUnit = triangleElem != null;
    };

    let textElem = element.querySelector('text');
    //TODO make replace to dynamic not static replace 
    textElem.style = textElem.getAttribute('style').replace('\'BrandonGrotesque-Medium\', \'Brandon Grotesque\', sans-serif', '\'Brandon Groeteque Med\'');
    let prevTextStyle = textElem.getAttribute('style');
    let textColor = "fill:#fff;";

    if (findEl!.floorPlanName == "The Addison" || findEl!.floorPlanName == "The McPherson") {
      textColor = "fill:#fff;"
    }

    rectElem.style = getFloorplanStyle(findEl!.floorPlanName, findEl!.status);

    let boundingBox = element.getBBox();
    //console.log(element.getBBox());
    let x = boundingBox.x;//rectElem.x.baseVal.value;
    let y = boundingBox.y;//rectElem.y.baseVal.value;
    let width = boundingBox.width;//rectElem.width.baseVal.value;
    let height = boundingBox.height;//rectElem.height.baseVal.value;
    let xOffset = elementID < 7 || elementID > 66 ? 4 : 4;
    let yOffset = elementID < 7 || elementID > 66 ? 0 : -3;

    if ((findEl.status == "Unavailable" || findEl.status == "AFF")
      && store.statusFilter != 'ComingSoon') {
      textColor = "fill:none;"
      //rectElem.onclick = () => {return false};
    }

    let cplace = element.querySelector('circle');
    if (cplace) {
      cplace.style = 'cursor: default;pointer-events: none;fill:none;';
    }

    let floorplanCheck = store.floorplanFilter != '' && store.floorplanFilter != findEl?.floorPlanName;
    let statusCheck = store.statusFilter != '' && store.statusFilter != findEl.status;
    let elevatorCheck = showOnlyElevator.value && triangleElem == null;

    if (floorplanCheck || statusCheck || elevatorCheck) {
      textColor = "fill:grey;"

      if (findEl.status == "AFF" || findEl.floorPlanName == "Amber") {
        textColor = "fill:none;"
      }

      if (triangleElem != null) {
        triangleElem.style = "fill:grey;pointer-events: none;";
      }

      rectElem.style = 'fill:#00000096;cursor: default;';
    } else if (findEl.status == "Sold" && !onlyCTA.value) {
      addSoldCircle();
    } else if (findEl.status == "Model" && !onlyCTA.value) {
      addModelCircle();
    } else if (findEl.status == "Available" && !onlyCTA.value) {
      addAvailableCircle();
    }

    textElem.style = prevTextStyle += ';cursor: default;pointer-events: none;' + textColor;

    function addModelCircle() {
      let cx = x + width / 2 - 4 + xOffset;
      let cy = y + height / 2 + 3 + yOffset;
      if (cplace != null) {
        cx = cplace.cx.baseVal.value;
        cy = cplace.cy.baseVal.value;
      }
      var circle2 = makeSVG('circle', { class: "tempCircle", cx: cx, cy: cy, r: 22, stroke: '#131E29', 'stroke-width': 4, fill: 'White', style: "default;pointer-events: none;" });
      element.appendChild(circle2);
    }

    function addSoldCircle() {
      let cx = x + width / 2 - 4 + xOffset;
      let cy = y + height / 2 + 3 + yOffset;
      if (cplace != null) {
        cx = cplace.cx.baseVal.value;
        cy = cplace.cy.baseVal.value;
      }
      var circle = makeSVG('circle', { class: "tempCircle", cx: cx, cy: cy, r: 22, stroke: 'white', 'stroke-width': 3, fill: '#F60808', style: "default;pointer-events: none;" });
      element.appendChild(circle);
    }
    function addAvailableCircle() {
      let cx = x + width / 2 - 4 + xOffset;
      let cy = y + height / 2 + 3 + yOffset;

      if (cplace != null) {
        cx = cplace.cx.baseVal.value;
        cy = cplace.cy.baseVal.value;

      }
      var circle = makeSVG('circle', { class: "tempCircle", cx: cx, cy: cy, r: 22, stroke: 'white', 'stroke-width': 3, fill: '#0b7f43', style: "default;pointer-events: none;" });
      element.appendChild(circle);
    }
  });
}


function initPanzoom() {
  var element = document.querySelector('#svgImage') as HTMLElement;

  let startX = element.offsetWidth * -0.02;//-125;
  let startY = element.offsetHeight * 0.09;//-25;
  let startScale = 3;
  if (onlyCTA.value) {
    startX = element.offsetWidth * -0.02;//-125;
    startY = element.offsetHeight * 0.00;//-25;
  }
  if (!isWideScreen.value) {
    startX = element.offsetWidth * -0.02;
    startY = element.offsetHeight * -0.01;
    startScale = 3;
  }

  panzoom = Panzoom(element, {
    maxScale: 6,
    minScale: 1,
    startScale: startScale,
    startY: startY,
    startX: startX,
    animate: true,
    duration: 250,
    contain: "outside",
    //panOnlyWhenZoomed: true
  });
  element!.parentElement!.addEventListener('wheel', panzoom.zoomWithWheel);

  var timeout: any;
  element.addEventListener('panzoomchange', function (event) {
    panning = true;
    // if(event.detail.scale > 1.5){
    //   theBarnLogoElement!.setAttribute('visibility', 'hidden');
    // }else{
    //   theBarnLogoElement!.setAttribute('visibility', 'visible');
    // }
    window.clearTimeout(timeout);
    timeout = setTimeout(() => {
      panning = false;
    }, 100);
  });

  zoomInRef.value.onclick = () => { panzoom.zoomIn(); };
  zoomOutRef.value.onclick = () => { panzoom.zoomOut(); };
  zoomResetRef.value.onclick = () => {
    panzoom.reset();
    store.floorplanFilter = '';
    store.statusFilter = '';
    showOnlyElevator.value = false;
    iterateSVG();
    filterModelChange('');
  };
}

function getFloorplanStyle(floorPlanName: string, lotStatus: string) {
  let default_cursor = "pointer"
  if (lotStatus == "AFF" || floorPlanName == "Amber") {
    default_cursor = "default";
  }
  return `fill:#00000000;cursor: ${default_cursor};`;
}

function makeSVG(tag: string, attrs: any) {
  var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
  for (var k in attrs)
    el.setAttribute(k, attrs[k]);
  return el;
}
function getFloorplanIndexFromName(floorplanName: string) {
  switch (floorplanName) {
    case 'The Sterling':
      return 0;
    case 'The Camden':
      return 1;
    default:
      return 0;
  }
}

function statusToText(status: string) {
  switch (status) {
    case "ComingSoon":
      return "Coming Soon"
    default:
      return status;
  }
}

function getFloorplanURL() {
  switch (lotFloorplanName.value) {
    case "The Addison":
      return "";
    case "The Braddock":
      // if (elevatorUnit) return "https://www.eya.com/townhomes/alexandria-va/banner-heights/homes-floorplans/cypress-with-elevator-model";
      return "https://www.eya.com/townhomes/falls-church-va/the-townhomes-at-west-falls/homes-floorplans/braddock-model";
    case "The Columbia":
      return "https://www.eya.com/townhomes/falls-church-va/the-townhomes-at-west-falls/homes-floorplans/columbia-model";
    case "The Dunn":
      return "https://www.eya.com/townhomes/falls-church-va/the-townhomes-at-west-falls/homes-floorplans/dunn-model";
    case "The McPherson":
      return "https://www.eya.com/townhomes/falls-church-va/the-townhomes-at-west-falls/homes-floorplans/mcpherson-model";
    default:
      return "";
  }
}

function getImageURL(): string {
  switch (lotFloorplanName.value) {
    case "The Addison":
      return braddockExterior.value.src;
    case "The Braddock":
      return braddockExterior.value.src;
    case "The Columbia":
      return columbiaExterior.value.src;
    case "The Dunn":
      return dunnExterior.value.src;
    case "The McPherson":
      return mcPhersonExterior.value.src;
    default:
      return braddockExterior.value.src;
  }
}

async function downloadSitePlan() {
  store.statusFilter = "";
  store.floorplanFilter = "";
  showOnlyElevator.value = false;
  iterateSVG();

  // if (store.statusFilter == "") return;

  const svg = document.querySelector('svg');
  if (svg) {
    showLoadingModal.value = true;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    let widthFormatOk = svg.width.baseVal.value.toString() == svg.width.baseVal.valueAsString;
    let heightFormatOk = svg.width.baseVal.value.toString() == svg.height.baseVal.valueAsString;
    let defaultWidth = '';
    let defaultHeight = '';
    if (!widthFormatOk || !heightFormatOk) {
      let viewBox = svg.viewBox.baseVal;
      if (viewBox) {
        defaultWidth = svg.width.baseVal.valueAsString;
        defaultHeight = svg.height.baseVal.valueAsString;
        //iOS canvas limit is 4096x4096 pixels
        let scaleRatio = 4096 / viewBox.width;

        svg.setAttribute("width", (4096).toString());
        svg.setAttribute("height", (Math.floor(viewBox.height * scaleRatio)).toString());
        canvas.width = 4096;
        canvas.height = Math.floor(viewBox.height * scaleRatio);
        console.log(canvas.width, canvas.height);
      }
    }
    //theBarnLogoElement!.setAttribute('visibility', 'hidden');

    const xml = new XMLSerializer().serializeToString(svg);
    const img = new Image();
    img.src = 'data:image/svg+xml;base64,' + btoa(xml);

    img.onload = async function () {
      ctx!.fillStyle = "white";
      ctx!.fillRect(0, 0, canvas.width, canvas.height);

      let i = 0;
      let maxAttempts = 25;
      let repeat = true;
      let cycle = [];
      let dataURL = "";

      while (repeat && i < maxAttempts) {
        console.log(i);
        ctx!.drawImage(img, 0, 0);
        await new Promise((resolve) => {
          setTimeout(() => resolve(null), 100)
        })
        dataURL = canvas.toDataURL("image/jpeg", 0.8);
        console.log("Data Size = ", dataURL.length);
        i++;
        cycle[i] = dataURL.length;

        if (dataURL.length >= cycle[i - 1]) repeat = false;
      }
      console.log("Finish draw");
      panzoom.reset();

      svg.setAttribute("width", defaultWidth);
      svg.setAttribute("height", defaultHeight);
      iterateSVG();
      // put file into form data
      var formdata = new FormData();
      formdata.append("siteplanImg", dataURL);
      console.error("Siteplan size:" + dataURL.length)
      const response = await fetch('https://homedesigner.truevistavr.com/fileAPI/siteplan/westfalls', {
        method: "POST",
        //TODO add some floorplan identifier number so know which page to use
        body: formdata
      })
        .then(res => {
          if (res.ok) {
            return res.blob()
          }
          throw new Error('Error occured')
        })
        .then(data => {
          console.log(data)
          var a = document.createElement("a")
          a.href = window.URL.createObjectURL(data)
          a.download = "EYA West Falls - Siteplan.pdf"
          a.click()
          showLoadingModal.value = false
        })
        .catch((error) => {
          console.log(error)
          showLoadingModal.value = false
        })
    }
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", {
      ref_key: "braddockExterior",
      ref: braddockExterior,
      src: _imports_0,
      hidden: ""
    }, null, 512),
    _createElementVNode("img", {
      ref_key: "columbiaExterior",
      ref: columbiaExterior,
      src: _imports_1,
      hidden: ""
    }, null, 512),
    _createElementVNode("img", {
      ref_key: "dunnExterior",
      ref: dunnExterior,
      src: _imports_2,
      hidden: ""
    }, null, 512),
    _createElementVNode("img", {
      ref_key: "mcPhersonExterior",
      ref: mcPhersonExterior,
      src: _imports_3,
      hidden: ""
    }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      (isWideScreen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[40] || (_cache[40] = _createElementVNode("div", { class: "titleText" }, "Explore the homes", -1)),
            _cache[41] || (_cache[41] = _createElementVNode("div", { class: "underTitleText" }, "Select your preferred model to see locations.", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "select_label" }, "Select Model", -1)),
                _createElementVNode("label", {
                  class: "select_label show_all",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {{ _isRef(floorplan) //@ts-ignore
 ? floorplan.value = '' : floorplan = ''; filterModelChange('') }})
                }, "Show All")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (!onlyCTA.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: _normalizeClass({ active_model: _unref(floorplan) == 'The Addison' }),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (filterModelChange('The Addison')))
                    }, [
                      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "square addison" }, null, -1)),
                      _createElementVNode("div", null, [
                        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "model_title" }, "The Addison", -1)),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(addisonPrice.value), 1)
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_7, [...(_cache[21] || (_cache[21] = [
                        _createElementVNode("img", {
                          class: "eye_img",
                          src: _imports_4
                        }, null, -1)
                      ]))], 512), [
                        [_vShow, _unref(floorplan) == 'The Addison']
                      ])
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'The Braddock' }),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (filterModelChange('The Braddock')))
                }, [
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "square braddock" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "model_title" }, "The Braddock", -1)),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(braddockPrice.value), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_9, [...(_cache[24] || (_cache[24] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_4
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'The Braddock']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'The Columbia' }),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (filterModelChange('The Columbia')))
                }, [
                  _cache[28] || (_cache[28] = _createElementVNode("div", { class: "square columbia" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "model_title" }, "The Columbia", -1)),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(columbiaPrice.value), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_11, [...(_cache[27] || (_cache[27] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_4
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'The Columbia']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'The Dunn' }),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (filterModelChange('The Dunn')))
                }, [
                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "square dunn" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "model_title" }, "The Dunn", -1)),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(dunnPrice.value), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_13, [...(_cache[30] || (_cache[30] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_4
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'The Dunn']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'The McPherson' }),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (filterModelChange('The McPherson')))
                }, [
                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "square mcpherson" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "model_title" }, "The McPherson", -1)),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(mcphersonPrice.value), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_15, [...(_cache[33] || (_cache[33] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_4
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'The McPherson']
                  ])
                ], 2)
              ])
            ]),
            (!onlyCTA.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", { class: "select_label" }, "Status", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event)),
                    onChange: filterStatusChange
                  }, [...(_cache[35] || (_cache[35] = [
                    _createElementVNode("option", {
                      value: "",
                      selected: ""
                    }, "All", -1),
                    _createElementVNode("option", { value: "Available" }, "Available", -1),
                    _createElementVNode("option", { value: "ComingSoon" }, "Coming Soon", -1),
                    _createElementVNode("option", { value: "Sold" }, "Sold", -1)
                  ]))], 544), [
                    [_vModelSelect, _unref(status)]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showOnlyElevator).value = $event)),
                id: "showOnlyElevator",
                onChange: iterateSVG
              }, null, 544), [
                [_vModelCheckbox, showOnlyElevator.value]
              ]),
              _cache[37] || (_cache[37] = _createElementVNode("label", { for: "showOnlyElevator" }, "Show only homes with elevator option", -1))
            ]),
            _createElementVNode("button", {
              class: "downloadButton",
              onClick: downloadSitePlan
            }, [...(_cache[38] || (_cache[38] = [
              _createElementVNode("img", { src: _imports_5 }, null, -1),
              _createTextVNode("DOWNLOAD SITE PLAN", -1)
            ]))]),
            (!onlyCTA.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[39] || (_cache[39] = [
                  _createStaticVNode("<div class=\"legendItem\" data-v-6514794c><div class=\"availableCircle\" data-v-6514794c></div>Available </div><div class=\"legendItem\" data-v-6514794c><div class=\"soldCircle\" data-v-6514794c></div>Sold </div><div class=\"legendItem\" data-v-6514794c><div class=\"modelCircle\" data-v-6514794c></div>Model Home </div><div class=\"legendItem\" data-v-6514794c><img class=\"legendIcon\" src=\"" + _imports_6 + "\" data-v-6514794c>Elevator option available </div>", 4)
                ]))]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!isWideScreen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[42] || (_cache[42] = [
            _createElementVNode("div", { class: "titleText" }, "Explore the homes", -1),
            _createElementVNode("div", { class: "underTitleText" }, "Select your preferred model to see locations.", -1)
          ]))]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", {
          id: "siteplanImage",
          ref_key: "siteplanImgContainer",
          ref: siteplanImgContainer
        }, [
          _createElementVNode("div", {
            ref_key: "svgDiv",
            ref: svgDiv,
            id: "svgImage"
          }, [...(_cache[43] || (_cache[43] = [
            _createElementVNode("div", { class: "loaderContainer" }, [
              _createElementVNode("div", { class: "loader" })
            ], -1)
          ]))], 512)
        ], 512),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", _hoisted_22, [
            _createElementVNode("img", {
              class: "legendButtonImg",
              ref_key: "zoomInRef",
              ref: zoomInRef,
              src: _imports_7
            }, null, 512)
          ]),
          _createElementVNode("button", _hoisted_23, [
            _createElementVNode("img", {
              class: "legendButtonImg",
              ref_key: "zoomOutRef",
              ref: zoomOutRef,
              src: _imports_8
            }, null, 512)
          ]),
          _createElementVNode("button", _hoisted_24, [
            _createElementVNode("img", {
              class: "legendButtonImg",
              ref_key: "zoomResetRef",
              ref: zoomResetRef,
              src: _imports_9
            }, null, 512)
          ])
        ])
      ]),
      (!isWideScreen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[44] || (_cache[44] = _createElementVNode("label", { class: "select_label" }, "Select Model", -1)),
                _createElementVNode("label", {
                  class: "select_label show_all",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => {{ _isRef(floorplan) //@ts-ignore
 ? floorplan.value = '' : floorplan = ''; filterModelChange('') }})
                }, "Show All")
              ]),
              _createElementVNode("div", _hoisted_28, [
                (!onlyCTA.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: _normalizeClass({ active_model: _unref(floorplan) == 'The Addison' }),
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (filterModelChange('The Addison')))
                    }, [
                      _cache[47] || (_cache[47] = _createElementVNode("div", { class: "square addison" }, null, -1)),
                      _createElementVNode("div", null, [
                        _cache[45] || (_cache[45] = _createElementVNode("div", { class: "model_title" }, "The Addison", -1)),
                        _createElementVNode("div", _hoisted_29, _toDisplayString(addisonPrice.value), 1)
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_30, [...(_cache[46] || (_cache[46] = [
                        _createElementVNode("img", {
                          class: "eye_img",
                          src: _imports_4
                        }, null, -1)
                      ]))], 512), [
                        [_vShow, _unref(floorplan) == 'The Addison']
                      ])
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'The Braddock' }),
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (filterModelChange('The Braddock')))
                }, [
                  _cache[50] || (_cache[50] = _createElementVNode("div", { class: "square braddock" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[48] || (_cache[48] = _createElementVNode("div", { class: "model_title" }, "The Braddock", -1)),
                    _createElementVNode("div", _hoisted_31, _toDisplayString(braddockPrice.value), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_32, [...(_cache[49] || (_cache[49] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_4
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'The Braddock']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'The Columbia' }),
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (filterModelChange('The Columbia')))
                }, [
                  _cache[53] || (_cache[53] = _createElementVNode("div", { class: "square columbia" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[51] || (_cache[51] = _createElementVNode("div", { class: "model_title" }, "The Columbia", -1)),
                    _createElementVNode("div", _hoisted_33, _toDisplayString(columbiaPrice.value), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_34, [...(_cache[52] || (_cache[52] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_4
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'The Columbia']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'The Dunn' }),
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (filterModelChange('The Dunn')))
                }, [
                  _cache[56] || (_cache[56] = _createElementVNode("div", { class: "square dunn" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[54] || (_cache[54] = _createElementVNode("div", { class: "model_title" }, "The Dunn", -1)),
                    _createElementVNode("div", _hoisted_35, _toDisplayString(dunnPrice.value), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_36, [...(_cache[55] || (_cache[55] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_4
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'The Dunn']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'The McPherson' }),
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (filterModelChange('The McPherson')))
                }, [
                  _cache[59] || (_cache[59] = _createElementVNode("div", { class: "square mcpherson" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[57] || (_cache[57] = _createElementVNode("div", { class: "model_title" }, "The McPherson", -1)),
                    _createElementVNode("div", _hoisted_37, _toDisplayString(mcphersonPrice.value), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_38, [...(_cache[58] || (_cache[58] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_4
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'The McPherson']
                  ])
                ], 2)
              ])
            ]),
            (!onlyCTA.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _cache[61] || (_cache[61] = _createElementVNode("label", { class: "select_label" }, "Status", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "mobile",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event)),
                    onChange: filterStatusChange
                  }, [...(_cache[60] || (_cache[60] = [
                    _createElementVNode("option", {
                      value: "",
                      selected: ""
                    }, "All", -1),
                    _createElementVNode("option", { value: "Available" }, "Available", -1),
                    _createElementVNode("option", { value: "ComingSoon" }, "Coming Soon", -1),
                    _createElementVNode("option", { value: "Sold" }, "Sold", -1)
                  ]))], 544), [
                    [_vModelSelect, _unref(status)]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_40, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((showOnlyElevator).value = $event)),
                id: "showOnlyElevator",
                onChange: iterateSVG
              }, null, 544), [
                [_vModelCheckbox, showOnlyElevator.value]
              ]),
              _cache[62] || (_cache[62] = _createElementVNode("label", { for: "showOnlyElevator" }, "Show only homes with elevator option", -1))
            ]),
            _createElementVNode("button", {
              class: "mobilDownloadButton",
              onClick: downloadSitePlan
            }, [...(_cache[63] || (_cache[63] = [
              _createElementVNode("img", { src: _imports_5 }, null, -1),
              _createTextVNode("DOWNLOAD SITE PLAN", -1)
            ]))]),
            (!onlyCTA.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [...(_cache[64] || (_cache[64] = [
                  _createStaticVNode("<div class=\"legendItem\" data-v-6514794c><div class=\"availableCircle\" data-v-6514794c></div>Available </div><div class=\"legendItem\" data-v-6514794c><div class=\"soldCircle\" data-v-6514794c></div>Sold </div><div class=\"legendItem\" data-v-6514794c><div class=\"modelCircle\" data-v-6514794c></div>Model Home </div><div class=\"legendItem\" data-v-6514794c><img class=\"legendIcon\" src=\"" + _imports_6 + "\" data-v-6514794c>Elevator option available </div>", 4)
                ]))]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(UnitModal, {
        isWideScreen: isWideScreen.value,
        show: showUnitModal.value,
        showForm: showEmbedForm.value,
        lotId: selectedLotId.value,
        onClose: _cache[17] || (_cache[17] = ($event: any) => (showUnitModal.value = false, showEmbedForm.value = false))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_42, _toDisplayString(modalTitleText.value), 1)
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, _toDisplayString(lotFloorplanName.value), 1),
            (lotUnitInfoText.value && !onlyCTA.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(lotUnitInfoText.value), 1))
              : _createCommentVNode("", true),
            (!onlyCTA.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(lotPriceText.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("img", {
            src: getImageURL(),
            class: "modalImagePreview"
          }, null, 8, _hoisted_47),
          (lotFloorplanName.value != 'The Addison' && !onlyCTA.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                target: "_parent",
                class: "modalLink",
                href: getFloorplanURL()
              }, "View Floor Plan Details", 8, _hoisted_48))
            : _createCommentVNode("", true),
          (!onlyCTA.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "formButton",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (showEmbedForm.value = true))
              }, "Contact Me About This Home"))
            : _createCommentVNode("", true),
          (onlyCTA.value && lotFloorplanName.value != 'The Addison')
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                class: "formButtonLink",
                target: "_parent",
                href: getFloorplanURL()
              }, "View Floor Plan Details", 8, _hoisted_49))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["isWideScreen", "show", "showForm", "lotId"])
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(FilterModal, {
        show: showFilterModal.value,
        onClose: _cache[18] || (_cache[18] = ($event: any) => (showFilterModal.value = false)),
        onFilter: iterateSVG,
        testWidth: 200
      }, {
        header: _withCtx(() => [...(_cache[65] || (_cache[65] = []))]),
        body: _withCtx(() => [...(_cache[66] || (_cache[66] = []))]),
        _: 1
      }, 8, ["show"])
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(LoadingModal, { show: showLoadingModal.value }, null, 8, ["show"])
    ]))
  ], 64))
}
}

})